<template lang="pug">
  v-container.pa-0(fluid)
    //- Dialogs
    v-dialog(transition="dialog-bottom-transition" fullscreen v-model='dialogOrder' v-if="dialogOrder")
      order-modal(:shop="shopSelected" @closeModalOrder="dialogOrder=false")
    v-dialog(max-width='380'  origin  v-model="loginDialog")
      login(userType="customer"  @close="loginDialog = false" @switchDialog="switchDialog('register')")
    v-dialog(  origin  v-model="registerDialog")
      register(userType="customer"  @close="registerDialog = false" @switchDialog="switchDialog('login')")
    //- Content
    v-app-bar#app-bar(:class="$route.name ==='home' && $route.path.includes('store') ? 'v-app-bar--is-scrolled' : ''" hide-on-scroll flat dark)
      template(v-slot:img="{ props }")
        v-img(v-bind="props" :gradient="`to right , #00bfd4, #008e95`")
      v-img(max-height='40px' max-width='50px' contain src="@/assets/logo-small-w.png" @click="setDrawer(!drawer)").logo-imageInput1
      //- Search
      v-spacer
      v-text-field.rounded-xl.pt-6(label='Buscar' color="white" height="10" dense elevation=0 outlined prepend-inner-icon='mdi-magnify' clearable style="max-width: 200px !important;")
      v-spacer
      //- v-img(max-height='60px' max-width='120px' contain src="@/assets/logo-2-w.png" @click="goto('/')" style="cursor: pointer;")
      v-btn.mr-3(elevation="0" fab color='transparent' flat  small="" @click="setDrawer(!drawer)").hidden-md-and-up
        v-icon(v-if="drawer")
          | mdi-close
        v-icon(large v-else)
          | mdi-menu
      .mx-3.hidden-xs-only
        v-btn(v-if='!user' small color="#05bdc8" @click="goto('/dashboard/')") Hazte Empresa
        v-btn.ml-2(small color="#cc84bf" @click="goto('/pages/login')") Tiendas
        //- Cart
        v-btn.ml-2(min-width="0" text="" v-bind="attrs" v-on="on")
          v-badge(v-if="cart.cartQty > 0" color="red" overlap="" bordered="").mr-3
            template(v-slot:badge="")
              span {{ cart.cartQty }}
            v-icon mdi-cart
          v-icon(v-else) mdi-cart
        //- v-list(:tile="false" nav="")
          //- Products
          span(v-if="cart.cartQty > 0")
            app-bar-item(v-for="(store, i) in cart.stores" :key="`item-${i}`")
              v-avatar(size='25px')
                img(style='object-fit:cover;' :src='store.data.pictures.imageInput1 === "" ? shopPlaceHolder : store.data.pictures.imageInput1')
              v-list-item-content(@click="selectShop(store)")
                v-list-item-title.d-flex
                  p.pl-3.pr-3 {{store.data.name + '  '}}
                  p {{store.qty | numberFormat}}
          //- no products
          span(v-else)
            app-bar-item
              v-list-item-content
                v-list-item-title(v-text="'No hay productos en la canasta'")
        //- Cupones
          v-menu(v-if="user" bottom="" left="" offset-y="" origin="top right" transition="scale-transition")
            template(v-slot:activator="{ attrs, on }")
              v-dialog(v-model="coupondialog" width="500")
                template(v-slot:activator="{ on, attrs }")
                  v-btn.ml-2(min-width="0" text="" v-bind="attrs" v-on="on")
                    v-icon mdi-sale
                    | Cupones
                v-card
                  v-card-title.headline.grey.lighten-2(primary-title="")
                    | Cupones
                  v-card-text
                    v-form(ref="form" v-model="valid" lazy-validation="")
                      v-text-field(v-model="couponcode" :rules="couponrules" label="Código de cupón" required="")
                    v-btn.mr-4(:disabled="!valid || loading" :loading="loading" color="success" @click="validateCoupon")
                      | Validar Cupón
                    v-btn(color="red" @click="coupondialog = false")
                      | Cancelar
        //- Favoritos
        v-menu(v-if="user" bottom="" left="" offset-y="" origin="top right" transition="scale-transition")
            template(v-slot:activator="{ attrs, on }")
              v-btn.ml-2.hidden-md(min-width="0" text="" v-bind="attrs" v-on="on" @click="goto('/profile/favorites')")
                v-icon mdi-cards-heart
        //- Notifications
        v-menu(v-if="user" bottom="" left="" offset-y="" origin="top right" transition="scale-transition" v-model="showMenu")
          template(v-slot:activator="{ attrs, on }")
            v-btn.ml-2.hidden-md(text v-bind="attrs" v-on="on"  @click="goto('/notifications')")
              v-badge(v-if="notifications.length > 0" color="red" overlap="" bordered="").mr-3
                template(v-slot:badge="")
                  span(v-if="notifications.length > 10") 10+
                  span(v-else) {{ notifications.length }}
                v-icon mdi-bell
              v-icon(v-else) mdi-bell
        //- Profile
        v-menu(v-if='user' bottom="" left="" min-width="200" offset-y="" origin="top right" transition="scale-transition")
          template(v-slot:activator="{ attrs, on }")
            v-btn.ml-2(min-width="0" text="" v-bind="attrs" v-on="on")
              v-icon mdi-account-circle
          v-list(:tile="false" flat="" nav="" v-for="(p, i) in profile")
            v-divider.mb-2.mt-2(:key="`divider-${i}`")
            v-list-item(@click="goto(p.to)")
              app-bar-item(:key="`item-${i}`")
                v-list-item-title( v-text="p.title")
        //- Init login
        v-btn.ml-2(v-if='!user' min-width="0" text="" @click="openLoginDialog")
          v-icon mdi-account-circle
</template>

<script>
  /* eslint-disable */
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import { auth } from '@/plugins/auth/firebase'
  import Cookie from 'js-cookie'
  import loaders from '@/plugins/mixins/loaders'
  import Swal from 'sweetalert2'
  import vars from '@/vars.json'
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  // Utilities
  export default {
    name: 'MarketplaceCoreAppBar',

    components: {
      login: () => import('@/views/pages/Login'),
      register: () => import('@/views/pages/Register'),
      OrderModal: () => import('@/views/marketplace/components/OrderModal'),
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },
    filters: {
      numberFormat (val) {
        if (val) {
          const fixed = Number.parseFloat(val).toFixed(0)
          return '$ ' + fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        } else return '$ 0'
      },
    },
    mixins: [loaders],

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      shopPlaceHolder: shopPlaceHolder,
      scrollTop: 0,
      coupondialog: false,
      loginDialog: false,
      registerDialog: false,
      showMenu: false,
      producstArray: [],
      valid: false,
      loading: false,
      couponcode: '',
      couponrules: [
        v => !!v || 'El codigo del cupón es requerido',
      ],
      dialogOrder: false,
      shopSelected: {},
    }),
    watch: {
      user: function () {
        this.loadNoRead()
      },
    },
    computed: {
      coupon () {
        return this.$store.getters['promotions/getCoupon']
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      user () {
        return this.$store.state.users.user
      },
      notifications () {
        return this.$store.getters['notifications/getNoRead']
      },
      profile () {
        if (!this.user) {
          return [
            { title: 'Mi perfil' },
            // { divider: true },
            {
              icon: 'mdi-fingerprint',
              title: 'Ingresar',
              to: '/pages/login',
            },
          ]
        } else {
          return [
            {
              title: 'Mi perfil',
              to: '/profile',
            },
            // { divider: true },
            { logout: true, title: 'Salir', to: 'salir' },
          ]
        }
      },
      barImage () {
        return this.$store.state.drawer.barImage
      },
      barColor () {
        return this.$store.state.drawer.barColor
      },
      drawer () {
        return this.$store.state.drawer.drawer
      },
      // Cantidad de productos en el carrito
      cart () {
        /* let totalProducts = 0
        
        this.$store.getters['pos/getCart'].forEach(store => {
          store.inventory.forEach(product => {
            if (product.data.magnitude) {
              totalProducts += 1
            } else {
              totalProducts += product.amount
            }
            producstArray.push({ qty: product.amount, name: product.data.name })
          })
        })
        return {cartQty: totalProducts, products: producstArray} */
        const vm = this
        const arrCart = this.$store.getters['pos/getCart']
        let storesArray = []
        arrCart.forEach(store => { 
          store.subtotal = 0
          store.inventory.forEach(product => {
            store.subtotal = (parseFloat(store.subtotal) + (parseFloat(vm.getPrice(product))) * (parseFloat(product.amount))).toFixed(2)
          })
          storesArray.push({ qty: store.subtotal, data: store })
        })
        return {cartQty: storesArray.length, stores: storesArray}
      },
    },
    /* watch: {
      $router (newVal, oldVal) {
        // console.log(newVal)
      },
    }, */
    created () {
      const vm = this
      if (vm.user) {
        vm.loadNoRead()
        vm.loadFavorites()
      }
    },
    mounted() {
      const vm = this;
      vm.fetch()
      window.addEventListener("scroll", function(){
        vm.scrollTop = window.scrollY
      });
      if (vm.user) {
        vm.loadNoRead()
      }
    },

    methods: {
      goto (to) {
        if (to !== 'salir') {
          this.$router.replace(to)
        } else {
          this.logout()
        }
      },
      fetch () {
        const vm = this
        vm.$store.dispatch('cms/loadItems', 'static').then(() => {
          vm.$store.commit('cms/setLoading', false)
        })
      },
      /* openBasket () {
        const vm = this
        vm.$store.dispatch('dialogs/openDialog', 'paymentWizDialog')
      }, */
      validateCoupon() {
        this.loading = true
        this.couponcode = this.couponcode.toUpperCase()
        this.$store.dispatch('promotions/couponValidator', this.couponcode).then(() =>{
          // console.log(this.coupon)
          if (this.coupon === '') {
            Swal.fire({
              icon: 'error',
              title: 'El código de cupón ingresado no está disponible',
              timer: 4500,
            })
          }else{
            Swal.fire({
              icon: 'success',
              title: `Cupón agregado disponible para usar en tienda ${this.coupon.availableShopName}`,
              timer: 7500,
            }).then(() => {
              this.coupondialog = false
            })
          }
          this.couponcode = ''
          this.loading = false
        })
      },
      saveSelectedCoupon() {
        this.$store.dispatch('promotions/saveCoupon', this.coupon)
        this.coupondialog = false
      },
      open () {
        const vm = this
        if (vm.notifications.length > 0 && vm.showMenu) {
          // Actualizar
          vm.$store.dispatch('notifications/UpdateNoRead')
        }
      },
      goNotifications () {
        if (this.notifications.length > 0) {
          // Actualizar
          // console.log('actualizar')
          this.$store.dispatch('notifications/UpdateNoRead')
          this.$router.replace('/notifications')
        }
      },
      switchDialog (to) {
        const vm = this
        switch (to) {
          case 'login':
            vm.registerDialog = false
            vm.loginDialog = true
            break
          case 'register':
            vm.loginDialog = false
            vm.registerDialog = true
            break
        }
      },
      openLoginDialog () {
        this.loginDialog = true
      },
      openRegisterDialog () {
        this.registerDialog = true
      },
      async logout () {
        const vm = this
        // console.log('logout')
        await auth.signOut()
        await Cookie.remove('access_token')
        vm.$store.dispatch('users/clearUser').then(function () {
          vm.$router.push('/').catch(err => {
            // console.log(err)
          })
        })
      },
      setDrawer (payload) {
        this.$store.dispatch('drawer/set_drawer', payload)
      },
      selectShop (store) {
        const vm = this
        if (vm.isMobile && store.data.id) {
          vm.$router.replace('/shop/' + store.data.subdomain)
        } else {
          const vm = this
          vm.shopSelected = {
            category: store.data.categories,
            data: {
              ...store.data,
            },
            id: store.data.id,
          }
          // console.log(vm.shopSelected)
          vm.dialogOrder = true
        }
      },
      getPrice (item) {
        // console.log(item)
        if (item.data.price.wholesale && +item.amount >= +item.data.price.wholesale.amount) {
          if (item.data.price.wholesale.percentage) {
            return item.data.price.sale - ((+item.data.price.sale * (+item.data.price.wholesale.price / 100).toFixed(2)).toFixed(2))
          } else {
            return +item.data.price.sale - +item.data.price.wholesale.price
          }
        } else {
          return +item.data.price.sale
        }
      },
    },
  }
</script>

<style>
  .v-text-field--outlined >>> fieldset {
    border-color: rgba(192, 0, 250, 0.986);
  }
  .v-app-bar {
    background: transparent !important;
  }
  .v-app-bar--is-scrolled {
    background: linear-gradient(to right, rgba(#3c8f9f, 0.8), rgba(#2e1b6d, 0.8)) !important;
  }
</style>
